import {useState, useCallback} from 'react';
import {message} from "antd";
import {useNavigate} from "react-router-dom";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import MicroQualificationService from "../../../../../../services/MicroQualificationService";

export const useDocumentPreview = (dataId, dataName) => {
    const navigate = useNavigate();
    const [isLoadingDocument, setIsLoadingDocument] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [documentPdf, setDocumentPdf] = useState(null);

    const triggerDownload = useCallback((blob, filename) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, []);

    const downloadDocument = useCallback(async () => {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        try {
            const response = await MicroQualificationService.getResource(dataId);
            message.destroy();
            message.success(<IntlMessage id={'success'}/>, 5);
            triggerDownload(response.data, (dataName || "document") + ".pdf");
        } catch (error) {
            message.destroy();
            message.error(<IntlMessage id={'error'}/>, 5);
        }
    }, [dataId, dataName, triggerDownload]);

    const getDocument = useCallback(async () => {
        setIsLoadingDocument(true);
        try {
            const response = await MicroQualificationService.getResource(dataId);
            message.success(<IntlMessage id={'success'}/>, 5);
            const file = new Blob([response.data], {type: "application/pdf"});
            const fileURL = URL.createObjectURL(file);
            setDocumentPdf(fileURL);
        } catch (error) {
            message.error(<IntlMessage id={'error'}/>, 5);
        } finally {
            message.destroy();
            setIsLoadingDocument(false);
        }
    }, [dataId]);

    const onDocumentLoadSuccess = useCallback(({numPages}) => {
        setNumPages(numPages);
        setIsLoadingDocument(false);
    }, []);

    const sendToCheck = useCallback(async () => {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        try {
            await MicroQualificationService.sendToCheck(dataId);
            message.destroy();
            message.success(<IntlMessage id={'success'}/>, 5);
            navigate("/p/microqualification");
        } catch (error) {
            message.destroy();
            message.error(<IntlMessage id={'error'}/>, 5);
        }
    }, [dataId, navigate]);

    return {
        isLoadingDocument,
        numPages,
        pageNumber,
        documentPdf,
        setPageNumber,
        downloadDocument,
        getDocument,
        onDocumentLoadSuccess,
        sendToCheck
    };
};
